var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormCategory.jinja');
require('./SubmissionFormCategory.less');

var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {

    },

    initialize: function (options) {
        this.options = options || {};

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    checkRequired: function () {
        var data = this.getFormData();

        if (data.category == undefined) {

            var $item = this.$('.SubmissionFormElement-header');

            $item.addClass('SubmissionFormElement-header--error');

            this.$('input[name="category"]').one('change', function () {
                $item.removeClass('SubmissionFormElement-header--error');
            });

            app.animateWindowScroll($item.offset().top - 80);

            return false;
        }

        return true;
    },


    getFormData: function () {
        return {
            'category': this.$('input[name="category"]:checked').val()
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormCategory.js
// module id = 111
// module chunks = 0